import { AnimatePresence, motion } from 'framer-motion';
import { crossSVG } from '../../lib/allCustomSVGs';
import '../../styles/popup/popup.scss';
import CustomSVGs from '../customSVGs/CustomSVGs';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  setTrigger: () => void;
  trigger: boolean;
  styles?: any;
  children: React.ReactNode;
  isCloseBtnHidden?: boolean;
  switching?: boolean;
  hideScroll?: boolean;
  overlayVariant?: 'default' | 'blur';
  additionalClassName?: string;
}

const Popup = ({
  trigger,
  setTrigger,
  styles,
  children,
  isCloseBtnHidden = false,
  switching = false,
  hideScroll = false,
  overlayVariant = 'default',
  additionalClassName = '',
}: Props) => {
  useEffect(() => {
    if (trigger) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [trigger]);

  if (!trigger) return null;

  // Use portal to render at document.body level to avoid stacking context issues
  return createPortal(
    <div className='popup'>
      <div
        className={`popup__overlay ${switching ? 'switching' : ''} ${
          overlayVariant === 'blur' ? 'popup__overlay--blur' : ''
        }`}
        onClick={() => {
          if (!switching) {
            setTrigger();
          }
        }}
      ></div>

      <AnimatePresence>
        <motion.div
          initial={{ x: '-50%', y: '-50%', opacity: 0, scale: 0.8 }}
          animate={{ x: '-50%', y: '-50%', opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{
            type: 'spring',
            stiffness: 280,
            damping: 20,
          }}
          style={styles}
          className={`popup__modal ${
            additionalClassName ? additionalClassName : ''
          }`}
          data-hide-scroll={hideScroll ? 'true' : 'false'}
        >
          {!isCloseBtnHidden && (
            <div
              onClick={() => {
                if (!switching) {
                  setTrigger();
                }
              }}
              className='popup__modal--closeBtn'
              style={{ cursor: switching ? 'not-allowed' : 'pointer' }}
            >
              <CustomSVGs svg={crossSVG}></CustomSVGs>
            </div>
          )}
          {children}
        </motion.div>
      </AnimatePresence>
    </div>,
    document.body
  );
};

export default Popup;
